export enum MathOperations {
    ADD,
    SUBTRACT
};